import type { MailContentProps, MailMetadata } from "../../lib/types";
import { calculateDateWithDateRelative } from "../../lib/utils";
import { MailSignature } from "../mail/mail-signature";

function ExtensionDeLAtelierDeProduction({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        Bonjour {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        J'aimerais avoir confirmation de la date de mise à disposition du nouvel
        atelier de production le{" "}
        {calculateDateWithDateRelative(
          Number(variablesData.livraison_atelier_production_date_prevue) || 0,
        )}
        . En raison du manque de fonctionnalité de nos actuelles installations
        l'extension et le réaménagement de nos bureaux techniques est une
        opération qui devient de plus en plus urgente. Un retard dans la
        construction du nouvel atelier aurait des conséquences graves sur
        l'ensemble de notre système productif.
      </p>
      <p>Je souhaite que tout se déroule conformément aux prévisions.</p>
      <p>Cordialement,</p>
      <MailSignature
        emetteurLogo={ExtensionDeLAtelierDeProduction.metadata.emetteurLogo}
        emetteur={ExtensionDeLAtelierDeProduction.metadata.emetteur}
        emetteurPoste={ExtensionDeLAtelierDeProduction.metadata.emetteurPoste}
        emetteurEntreprise={
          ExtensionDeLAtelierDeProduction.metadata.emetteurEntreprise
        }
      />
    </div>
  );
}

ExtensionDeLAtelierDeProduction.metadata = {
  titre: "Extension de l'atelier de Production",
  cleMail: "extension_de_l_atelier_de_production",
  messageTransfert: false,
  emetteur: "Claude LEBLANC",
  emetteurPoste: "Responsable Production",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -2,
  piecesJointes: [],
} as MailMetadata;

export default ExtensionDeLAtelierDeProduction;
